import { useEffect } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { TimeSlotType } from 'shared-types/SpaPackage';

import { SpaPackageFormValues } from '../../SpaPackageForm.schema';

type UseAutoAdvanceHiddenArrivalParams = {
  form: UseFormReturn<SpaPackageFormValues>;
  hideArrivalTimes: boolean;
  daySlots: TimeSlotType[] | undefined;
  selectedTime: string | undefined;
  selectedSlotUnavailable: boolean;
  isCheckingSlot: boolean;
};

export function useAutoAdvanceHiddenArrival({
  form,
  hideArrivalTimes,
  daySlots,
  selectedTime,
  selectedSlotUnavailable,
  isCheckingSlot,
}: UseAutoAdvanceHiddenArrivalParams) {
  const slots = Array.isArray(daySlots) ? daySlots : [];
  const currentIndex = selectedTime
    ? slots.findIndex((slot) => slot.startTime === selectedTime)
    : -1;

  useEffect(() => {
    if (!hideArrivalTimes || slots.length === 0) return;
    if (isCheckingSlot || !selectedSlotUnavailable) return;
    const nextSlot = currentIndex >= 0 ? slots[currentIndex + 1] : undefined;
    if (nextSlot) {
      form.setValue('arrivalTime', nextSlot);
    }
  }, [hideArrivalTimes, slots, selectedSlotUnavailable, isCheckingSlot, currentIndex, form]);

  const noBookableSlot =
    hideArrivalTimes &&
    slots.length > 0 &&
    !isCheckingSlot &&
    selectedSlotUnavailable &&
    currentIndex === slots.length - 1;

  return { noBookableSlot };
}
